export default __webpack_public_path__ + "static/media/Electric Hook Up - Coral.98e1d4c3.svg";